/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { PullRequest } from '~shared/types/branch-like';

export interface CurrentBranchLikeMergeInformationProps {
  pullRequest: PullRequest;
}

export function CurrentBranchLikeMergeInformation({
  pullRequest,
}: Readonly<CurrentBranchLikeMergeInformationProps>) {
  const intl = useIntl();

  return (
    <span
      className="sw-max-w-[400px] sw-truncate"
      title={intl.formatMessage(
        { id: 'branch_like_navigation.for_merge_into_x_from_y.title' },
        {
          target: pullRequest.target,
          branch: pullRequest.branch,
        },
      )}
    >
      <FormattedMessage
        id="branch_like_navigation.for_merge_into_x_from_y"
        values={{
          target: <strong>{pullRequest.target}</strong>,
          branch: <strong>{pullRequest.branch}</strong>,
        }}
      />
    </span>
  );
}

export default React.memo(CurrentBranchLikeMergeInformation);
